import { type ButtonHTMLAttributes } from 'react';
import { buttonClass, type ButtonVariant } from './utils.js';

export function Button(
  props: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: ButtonVariant | undefined },
) {
  const { variant = 'primary', className, ...rest } = props;
  return <button {...rest} className={buttonClass(variant, className)} />;
}
